import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { useMediaQuery } from './useMediaQuery';

export function useMediaSize() {
    const theme = useContext(ThemeContext)!;
    const isDesktop = useMediaQuery(`(min-width: ${ parseInt(theme.breakpoints.desktop) + 1 }px)`);
    const isTablet = useMediaQuery(`(min-width: ${ theme.breakpoints.tablet }) and (max-width: ${ theme.breakpoints.desktop })`);
    const isMobile = !isDesktop && !isTablet;

    return {
        isDesktop,
        isTablet,
        isMobile
    };
}
